/**
 * @generated SignedSource<<bcc0b1fb97c9eb75e129c8d58cfeafd9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HomePage_authenticationConfig",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SimpleMenuMainNavigation_authenticationConfig"
    }
  ],
  "type": "AuthenticationConfig",
  "abstractKey": null
};

node.hash = "d120932d06bfbe1bb8614d9e864e2786";

module.exports = node;
